import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as Constants from '../../Constants/index';
import { Table } from 'reactstrap'; 
import { saveAs } from 'file-saver';
import Pagination from 'react-js-pagination'; // Import react-js-pagination
import swal from 'sweetalert';

const SalesHierarchyReport = () => {
  const [result, setResult] = useState([]);
  const [limit] = useState(50); 
  const [totalPages, setTotalPages] = useState(1); 
  const [currentPage, setCurrentPage] = useState(1); 
  const [searchRecord, setSearchRecord] = useState();
  const [loading, setLoading] = useState(false);
  const [phoneNum, setPhoneNum] = useState('');
  const [statusFilter, setStatusFilter] = useState('SALES');
  const [excelType , setExcelType] = useState('SALES') 

  // Function to fetch data from the API
  const getData = async (page = 1) => {
    let token = localStorage.getItem('token');
    try {
      setLoading(true);
      let url = `${Constants.api}/reports/salesHierchy/list?sortAsc=true&limit=${limit}&page=${page}&userType=${statusFilter}`;  
      if (phoneNum) {
        url += `&mobile=${phoneNum}`;  // Append phoneNum parameter correctly
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Accept-Language': localStorage.getItem('langauge'),
          appVersion: Constants.av,
          platform: Constants.pt,
          company: 1,
          program: 1,
        },
      });

      const data = response.data?.output || {};
      setResult(data.results || []);
      setTotalPages(data.totalPages || 1); 
      setSearchRecord(data.results ? data.results.length > 0 : false);
      setLoading(false);
    } catch (error) {
      console.log('Error fetching data:', error);
      setLoading(false);
    }
  };

  const download = () => {
    let token = localStorage.getItem('token');
    try {
      setLoading(true);
      axios.get(`${Constants.api}/reports/download/salesHierchy?userType=${statusFilter}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Accept-Language': localStorage.getItem('langauge'),
          appVersion: Constants.av,
          platform: Constants.pt,
          company: 1,
          program: 1,
        },
        responseType: 'blob',
      }).then((res) => {
        if (res.status === 200) {
          setLoading(false);
          const fileData = new Blob([res.data], { type: 'text/csv' });
          saveAs(fileData, 'SalesHierarchyReport.csv');
        } else {
          swal({
            text: res.data.msg,
            timer: 2000,
            buttons: false,
          });
        }
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData(currentPage);
  }, [currentPage, statusFilter, phoneNum]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  return (
    <>
      <section className="blog-area pt182">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group has-float-label style-two">
              <label htmlFor="statusSelect">Select Status <sup>*</sup></label>
              <select
                id="statusSelect"
                className="form-control2"
                style={{ color: "Gray" }}
                value={statusFilter}
                onChange={handleStatusChange}
              >
                <option value="SALES">SALES</option>
                {/* <option value="">All</option> */}
                <option value="MK">MK</option>
              </select>
            </div>
          </div>
          <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="form-group has-float-label style-two">
            </div>
            <input
              type="text"
              name="phoneNumber"
              placeholder="SALES/MK MOBILE"
              maxLength="10"
              value={phoneNum}
              onChange={(e) => setPhoneNum(e.target.value)}
              style={{ height: "40px", textAlign: "center" }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="carrd1">
              <div className="card-header card-header-warning d-flex justify-content-between">
                <h4 className="card-title">
                  Sales Hierarchy Report&nbsp;
                </h4>
                {searchRecord ? (
                  <div className='d-flex '>
                {/* <div className="form-group has-float-label style-two">
                <label htmlFor="statusSelect">Report Type</label>
                <select
                id="statusSelect"
                className="form-control2"
                style={{ color: "Gray" }}
                value={excelType}
                onChange={(e) => setExcelType(e.target.value)}
                >
                <option value="SALES">SALES</option>
                <option value="MK">MK</option>
              </select>
            </div> */}
                  <h4>
                    <button onClick={download} className="btn btn-primary">
                      Export
                    </button>
                  </h4>
                  </div>
                ) : null}
              </div>

              <div className="card-body table-responsive">
                <Table striped>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>USER-TYPE</th>
                      <th>SALES/MK Id</th>
                      <th>SALES/MK NAME</th>
                      <th>SALES/MK MOBILE</th>
                      <th>SH ID</th>
                      <th>SH NAME</th>
                      <th>SH MOBILE</th>
                      <th>RO ID</th>
                      <th>RO NAME</th>
                      <th>RO MOBILE</th>
                      <th>ZO ID</th>
                      <th>ZO NAME</th>
                      <th>ZO MOBILE</th>
                    </tr>
                  </thead>
                  {result.length === 0 ? (
                    <tbody>
                      <tr>
                        <td colSpan="14" style={{ textAlign: 'center', fontSize: '16px' }}>
                          No record found!
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody style={{ textAlign: "center" }}>
                    {result
                      .filter((val) => val[0] === "MK" || val[0] === "SALES") // Filter based on the first index value
                      .map((val, index) => (
                        <tr key={index}>
                          <td>{index + 1 + (currentPage - 1) * limit}</td>
                          <td>{val[0]}</td>
                          <td>{val[1]}</td>
                          <td>{val[2]}</td>
                          <td>{val[3]}</td>
                          <td>{val[4]}</td>
                          <td>{val[5]}</td>
                          <td>{val[6]}</td>
                          <td>{val[7]}</td>
                          <td>{val[8]}</td>
                          <td>{val[9]}</td>
                          <td>{val[10]}</td>
                          <td>{val[11]}</td>
                          <td>{val[12]}</td>
                        </tr>
                      ))}
                  </tbody>
                  
                  )}
                </Table>

                {totalPages > 1 && (
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={limit}
                    totalItemsCount={totalPages * limit}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                    activeClass="active"
                    prevPageText="<"
                    nextPageText=">"
                    firstPageText="<<"
                    lastPageText=">>"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SalesHierarchyReport;
